import { action, makeObservable, observable } from "mobx";
import { makePersistable } from "mobx-persist-store";
import { getSubscriptionDetailsApi } from "../Api";
import { consoleLogger } from "../Functions";

class SubscriptionState {
  subscritionDetails = {};
  constructor() {
    makeObservable(this, {
      subscritionDetails: observable,
      init: action,
      resetStore: action,
      fetchSubscriptionDetails: action,
      isFeatureAvailableWithAddOns: action,
    });

    makePersistable(this, {
      name: SubscriptionState,
      storage: window.localStorage,
      expireIn: 86400000,
      removeOnExpiration: true,
      stringify: true,
      debugMode: false,
      properties: [""],
    });
  }

  fetchSubscriptionDetails = async () => {
    let response = await getSubscriptionDetailsApi();
    if (response.length > 0) {
      this.subscritionDetails = response[0];
    }
  };

  resetStore = () => {
    this.subscritionDetails = {};
  };

  init = async () => {
    await this.fetchSubscriptionDetails();
  };

  isFeatureAvailableWithAddOns = (featureName) => {
    if (
      this.subscritionDetails.hasOwnProperty("subscription_addons") &&
      this.subscritionDetails["subscription_addons"] !== null
    ) {
      for (
        let i = 0;
        i < this.subscritionDetails["subscription_addons"].length;
        i++
      ) {
        let addOnData = this.subscritionDetails["subscription_addons"][i];
        if (addOnData["active"] === true && addOnData["name"] === featureName) {
          return true;
        }
      }
    }
    return false;
  };

  getMaxUsersWithAddOns = () => {
    let tempMaxUsers =
      this.subscritionDetails["max_users"] !== null &&
      this.subscritionDetails["max_users"] > 0
        ? this.subscritionDetails["max_users"]
        : 0;
    if (
      this.subscritionDetails.hasOwnProperty("subscription_addons") &&
      this.subscritionDetails["subscription_addons"] !== null
    ) {
      this.subscritionDetails["subscription_addons"].forEach((addOnPack) => {
        if (
          addOnPack["name"] === "Additional User Pack" &&
          addOnPack["active"] === true &&
          addOnPack["value"] !== null &&
          addOnPack["value"] > 0
        ) {
          tempMaxUsers += addOnPack["value"];
        }
      });
    }
    return tempMaxUsers;
  };

  hasReachedMaxUserLimit = ({ totalUsers }) => {
    if (Object.keys(this.subscritionDetails).length > 0) {
      const maxUsers = this.getMaxUsersWithAddOns();
      consoleLogger("max users ::::", maxUsers);
      if (maxUsers > 0) {
        return totalUsers >= maxUsers;
      }
    }
    return false;
  };
}

export default SubscriptionState;
